import React from 'react';

import SharedMonomerCreationMethodPicker from 'molbio/monomers/admin/SharedMonomerCreationMethodPicker';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {useCanCreateAaMonomersAndRedirect} from './useCanCreateAaMonomers';

export default function AaMonomerCreationMethodPicker(): JSX.Element {
  const {isLoading} = useCanCreateAaMonomersAndRedirect();

  if (isLoading) {
    return <CenteredHorizontalThrobber />;
  }

  return (
    <SharedMonomerCreationMethodPicker
      helmLibraryUrl="/aa-monomers/create/helm-library"
      csvUploadUrl="/aa-monomers/create/bulk-csv"
      manualCreateUrl="/aa-monomers/create/manual"
      libraryName="AA Monomer library"
      libraryUrl="/aa-monomers/listing"
    />
  );
}
